// extracted by mini-css-extract-plugin
module.exports = {"avatarWrapper":"avatar_avatarWrapper__2V1dY","avatar":"avatar_avatar__1kjqw","badge":"avatar_badge__2El_-"};